<template>
    <!-- Authors Table Card -->
    <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
        <a-row :gutter="24" type="flex">
            <!-- Authors Table Column -->
            <a-col :span="24" class="mb-24">
                <a-form layout="inline" :form="dataForm" @submit="getDataList" class="ml-20">
                    <!-- <a-form-item label="角色名称">
                        <a-input v-model="dataForm.role_name" placeholder="角色名称" />
                    </a-form-item> -->
                    <a-form-item>
                        <a-button type="" @click="getDataList" :loading="dataListLoading">刷新数据</a-button>
                    </a-form-item>
                    <a-form-item>
                        <a-button type="primary" @click="addOrUpdateHandle()">新增日程</a-button>
                    </a-form-item>
                </a-form>
                <a-table :scroll="{ x: 1550 }" :columns="columns" :data-source="dataList" :pagination="false"
                    rowKey="id" :loading="dataListLoading">
                    <template slot="department.department_name" slot-scope="department_name">
                        <a-tag>{{ department_name }}</a-tag>
                    </template>
                    <template slot="editBtn" slot-scope="text, row">
                        <a-button type="link" class="btn-edit" @click="addOrUpdateHandle(row.tripday_id)">
                            编辑
                        </a-button>
                        <a-button type="link" class="btn-edit" @click="deleteHandle(row.tripday_id)">
                            删除
                        </a-button>
                    </template>
                </a-table>
            </a-col>
            <!-- / Authors Table Column -->
        </a-row>
        <a-pagination class="mr-20 float-right" show-size-changer :current="page" :total="total"
            :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange"
            @change="pageCurrentChangeHandle" />
        <addorupdate ref="addOrUpdate" @ok="getDataList" :trip_id="trip_id"></addorupdate>
    </a-card>
    <!-- / Authors Table Card -->
</template>

<script>
import viewModule from "@/mixins/view-module";
import addorupdate from "./addorupdatetripdays.vue";
export default {
    mixins: [viewModule],
    props: ['trip_id'],
    components: {
        addorupdate,
    },
    data() {
        return {
            mixinViewModuleOptions: {
                getDataListURL: "/admin/tripdays/page",
                deleteURL: "/admin/tripdays/delete",
            },
            dataForm: {
                trip_id: this.trip_id,
            },
            columns: [
                {
                    title: "出行日期",
                    dataIndex: "day",
                    width: 200
                },
                {
                    title: "行程地点",
                    dataIndex: "title",
                    width: 200
                },
                {
                    title: "行程配置",
                    dataIndex: "subtitle",
                    width: 400
                },
                {
                    title: "详细计划",
                    dataIndex: "detail",
                    width: 400
                },
                {
                    title: "操作",
                    scopedSlots: { customRender: "editBtn" },
                    width: 300,
                    fixed: "right",
                },
            ],
        };
    },
    methods: {},
};
</script>